<template>
  <zen-one 
    :showuserinfo="false" 
    :crumbs="crumbs"
    title="Maklumat Pengguna"
  >
    <z-page 
      :title="user.name" 
      icon="fal fa-user"
    >
      <template #buttons>
        <w-button icon="fal fa-circle" text md class="ml0" color="success"></w-button>
      </template>

      <w-card bg-color="z-pale-blue" class="mt4">
        <w-flex justify-center align-center>
        <div class="xs3">
          <w-image
            class="maa sh1 bdrsr d-block"
            src="/images/avatar.png" 
            :width="100"
            :height="100">
          </w-image>
        </div>
        <div class="xs9">
          <w-flex class="mt3">
            <div class="xs4">
                <h5 class="fw-semibold m0">
                    Nama :
                </h5>
                <div class="fw-normal my1 fs-1"> {{ user.name }} </div>
            </div>
            <div class="xs4">
                <h5 class="fw-semibold m0">
                    E-mel :
                </h5>
                <div class="fw-normal my1 fs-1"> {{ user.email}} </div>
            </div>
          </w-flex>

          <w-flex class="mt3 mb4">
            <div class="xs4">
              <h5 class="fw-semibold m0">
                  Tarikh Cipta :
              </h5>
              <div class="fw-normal my1 fs-1"> {{ $zutil.dateformat(user.created_at) }} </div>
            </div>
              <div class="xs4">
                  <h5 class="fw-semibold m0">
                      Tarikh Ubah Akhir :
                  </h5>
                  <div class="fw-normal my1 fs-1"> {{ $zutil.dateformat(user.updated_at) }} </div>
              </div>
          </w-flex>
        </div>
        </w-flex>

        <w-tabs
          :items="tabs"
          :no-slider="false"
          active-class="primary">
          <template #item-content.1>
            <permission
              title="Senarai Peranan"
              :user="user"
              :items="roles"
              which="role"
              v-model:selected="user.roles_id"
              >
            </permission>                
          </template>

          <template #item-content.2>
            <permission
              title="Senarai Kebenaran"
              :user="user"
              :items="permissions"
              which="permission"
              v-model:selected="user.permissions_id"
              >
            </permission>                
          </template>
        </w-tabs>

      </w-card>
        
    </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import Permission from './Subs/Permission.vue'


export default {
  components: {
    Permission
  },
  props: {
    user: [Array, Object],
    roles: [Array, Object],
    permissions: [Array, Object],
  },
  data() {
    return {
      data: {
        permissions: [],
        roles: [],
      },
      crumbs: [
        { label: this.$page.props.app_name, route: '/sitemap' },
        { label: 'Pentadbiran', route: '/administration' },
        { label: 'Pengguna', route: '/administration/user' },
        { label: this.user.name , route: '/administration/user' }
      ],
      tabs: [
        { title: 'Peranan', content: '' },
        { title: 'Kebenaran', content: 'Pipizola' },
      ],
    }
  },
  methods: {
  
  },
  watch: {

  },
  mounted() {
    
      
  },
}
</script>